module.exports = __webpack_public_path__ + "static/media/unpublish.5da72911.svg";